import React from "react";

import { SortableElement } from "react-sortable-hoc";

import imgThumbnail1 from "styles/common/img/common/menubar.png";

const SortableItem = SortableElement(({ value }) => (
    <li className="sortable__li">
        <div className="moveingBox">
            <div className="moveText fl">{value}</div>
            <div className="moveImg fr">
                <img src={imgThumbnail1} alt="move" />
            </div>
        </div>
    </li>
));

export default SortableItem;
